import * as Safe from "safe-portals";

const objectFromEntries = (arr: any) => Object.assign({}, ...[...arr].map(([k, v]) => ({ [k]: v })));

export interface SafeQueryParser<T> {
  toQueryString: (t: T) => string;
  fromQueryString: (q: string) => T | "NoMatch";
}

/**
 * Safe url query string parsing
 */
export function makeSafeQueryParser<T>(args: Safe.Obj<T>): SafeQueryParser<T> {
  return {
    /**
     * Turn ts objects like:
     *  { guid: 'myguid', member: { name: 'Tom' }, page: 2 }
     * into query strings like:
     * guid=%22myguid%22&member=%7B%22name%22%3A%22Tom%22%7D&page=2
     */
    toQueryString: (t: T): string => {
      const o: any = args.write(t);
      return Object.keys(o)
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(JSON.stringify(o[k]))}`)
        .join("&");
    },
    /**
     * Reverseof toQueryString. Can indicate no match.
     */
    fromQueryString: (q: string): T | "NoMatch" => {
      try {
        return args.read(
          objectFromEntries(
            q
              .split("&")
              .filter((v) => v !== "") // ''.split('&') === ['']
              .map((pair) => pair.split("="))
              .map((kv) => [decodeURIComponent(kv[0]), JSON.parse(decodeURIComponent(kv[1]))])
          )
        );
      } catch (e) {
        if (e instanceof SyntaxError || e instanceof Safe.ValidationError || e instanceof URIError) {
          return "NoMatch";
        } else {
          throw e;
        }
      }
    },
  };
}
